module.exports = __webpack_public_path__ + "img/img-cup.4a80ef2a.png";